import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
    ENQUEUE_NOTIFICATION,
    CLEAR_NOTIFICATION,
    clearNotification,
} from "../actions/notifications";

const notificationListenerMiddleware = createListenerMiddleware();

notificationListenerMiddleware.startListening({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    predicate: (action: any) => action.type === ENQUEUE_NOTIFICATION && action.payload?.autoClear,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    effect: async (action: any, listenerApi) => {
        const { payload } = action;

        const result = await listenerApi.condition(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (condAction: any) =>
                condAction.type === CLEAR_NOTIFICATION && condAction.payload?.id === payload.id,
            2500,
        );

        if (!result) {
            listenerApi.dispatch(clearNotification(payload));
        }
    },
});

export default notificationListenerMiddleware;
